import { defineStore } from 'pinia';
import authService from '../services/authService';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null
  }),

  getters: {
    currentUserName: (state) => state.user?.name || '',
    currentUserId: (state) => state.user?.id || null
  },

  actions: {
    /**
     * Faz login com username e password
     * @param {string} username
     * @param {string} password
     * @returns {Promise<boolean>} true se login OK, false caso contrário
     */
    async login(username, password) {
      this.loading = true;
      this.error = null;

      try {
        const response = await authService.login(username, password);
        this.user = response.user;
        this.isAuthenticated = true;
        return true;
      } catch (err) {
        this.error = err.message || 'Erro ao fazer login';
        this.user = null;
        this.isAuthenticated = false;
        return false;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Encerra sessão
     */
    async logout() {
      this.loading = true;
      try {
        await authService.logout();
      } catch (err) {
        console.error('Logout error:', err);
      } finally {
        this.user = null;
        this.isAuthenticated = false;
        this.error = null;
        this.loading = false;
      }
    },

    /**
     * Verifica se sessão está ativa (chamado no carregamento da app)
     * @returns {Promise<boolean>} true se autenticado
     */
    async checkAuth() {
      try {
        const response = await authService.getMe();
        this.user = response.user;
        this.isAuthenticated = true;
        return true;
      } catch (err) {
        this.user = null;
        this.isAuthenticated = false;
        return false;
      }
    },

    clearError() {
      this.error = null;
    }
  }
});
